import { combineReducers } from "redux";
import useAuthReducers from "./auth";
import useToolsReducers from "./tools";
import useUserReducers from "./users";
import useRoleReducers from "./roles";
import useProjectReducer from "./projects";

const useReducers = () => {
  const { session, mfaPending } = useAuthReducers();
  const {
    addTools,
    savedQuestions,
    conditionalsList,
    organizeToolsAI,
  } = useToolsReducers();
  const { userSelected } = useUserReducers();
  const { roleSelected } = useRoleReducers();
  const { projectSelected } = useProjectReducer();

  return combineReducers({
    session,
    mfaPending,
    addTools,
    userSelected,
    roleSelected,
    savedQuestions,
    projectSelected,
    conditionalsList,
    organizeToolsAI,
  });
};

export default useReducers;
